const cards = [
  {
    icon: 'ri-quill-pen-line',
    title: 'The Works',
    sub: 'Plays, poetry & prose',
    desc: "From 'Death and the King\'s Horseman' to 'A Dance of the Forests' — a complete literary catalogue.",
  },
  {
    icon: 'ri-award-line',
    title: 'The Legacy',
    sub: 'Nobel 1986 · Activism',
    desc: 'First sub-Saharan African to receive the Nobel Prize in Literature, and a lifelong voice for freedom.',
  },
  {
    icon: 'ri-drama-line',
    title: 'The Voice',
    sub: 'Speeches & memory',
    desc: 'Powerful words on justice, culture, and the human condition that echo across generations.',
  },
];

export default function FeatureCards() {
  return (
    <section className="w-full px-6 md:px-12 py-12">
      <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-5">
        {cards.map((card) => (
          <div
            key={card.title}
            className="relative rounded-2xl p-7 flex flex-col gap-4 group cursor-pointer transition-all duration-400"
            style={{
              background: '#141414',
              border: '1px solid rgba(201, 168, 76, 0.18)',
              boxShadow: '0 0 30px rgba(201,168,76,0.04)',
            }}
          >
            <div
              className="w-11 h-11 flex items-center justify-center rounded-full"
              style={{ background: 'rgba(201,168,76,0.08)', border: '1px solid rgba(201,168,76,0.25)' }}
            >
              <i className={`${card.icon} text-xl`} style={{ color: '#C9A84C' }} />
            </div>
            <div>
              <h3
                className="text-lg font-light mb-0.5"
                style={{ fontFamily: "'Cormorant Garamond', serif", color: '#F5F0E8' }}
              >
                {card.title}
              </h3>
              <span
                className="text-[10px] tracking-widest uppercase"
                style={{ fontFamily: "'Inter', sans-serif", color: '#9A9A8A' }}
              >
                {card.sub}
              </span>
            </div>
            <p
              className="text-sm leading-relaxed font-light"
              style={{ fontFamily: "'Inter', sans-serif", color: '#9A9A8A' }}
            >
              {card.desc}
            </p>
            <div
              className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
              style={{ background: 'radial-gradient(ellipse at top left, rgba(201,168,76,0.06), transparent 70%)' }}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
